/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * reserveShiftReport
 * @export
 * @interface ReserveShiftsRequest
 */
export interface ReserveShiftsRequest {
    /**
     * 営業所ID
     * @type {number}
     * @memberof ReserveShiftsRequest
     */
    officeId?: number;
    /**
     * multiple営業所で検索のためのリスト
     * @type {Array<number>}
     * @memberof ReserveShiftsRequest
     */
    officeIds?: Array<number>;
    /**
     * multiple乗務員で検索のためのリスト
     * @type {Array<number>}
     * @memberof ReserveShiftsRequest
     */
    driverIds?: Array<number>;
    /**
     * 乗務日(年月日 yyyymmddで返される)
     * @type {number}
     * @memberof ReserveShiftsRequest
     */
    shiftStartDate?: number;
    /**
     * 年月日
     * @type {number}
     * @memberof ReserveShiftsRequest
     */
    shiftEndDate?: number;
}

export function ReserveShiftsRequestFromJSON(json: any): ReserveShiftsRequest {
    return ReserveShiftsRequestFromJSONTyped(json, false);
}

export function ReserveShiftsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReserveShiftsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'officeId': !exists(json, 'office_id') ? undefined : json['office_id'],
        'officeIds': !exists(json, 'office_ids') ? undefined : json['office_ids'],
        'driverIds': !exists(json, 'driver_ids') ? undefined : json['driver_ids'],
        'shiftStartDate': !exists(json, 'shift_start_date') ? undefined : json['shift_start_date'],
        'shiftEndDate': !exists(json, 'shift_end_date') ? undefined : json['shift_end_date'],
    };
}

export function ReserveShiftsRequestToJSON(value?: ReserveShiftsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'office_id': value.officeId,
        'office_ids': value.officeIds,
        'driver_ids': value.driverIds,
        'shift_start_date': value.shiftStartDate,
        'shift_end_date': value.shiftEndDate,
    };
}


